// Thresholds that need to be reached so a click
// and mouse move is considered a selection
export const MOUSE_MOVE_THRESHOLD_X = 5
export const MOUSE_MOVE_THRESHOLD_Y = 5